import * as React from 'react'
import styled from '../../utils/styled'
import Loadingbar from './Loaderbar'
import Gallery from './IndexLayoutGallery'

interface IndexLayoutProps {
  loading: boolean,
  title: string,
  subtitle: string,
  category: string,
  size: any,
  data: any,
  logo: string,
  history: any,
  fetchRequest: any,

}

const IndexLayout: React.SFC<IndexLayoutProps> = ({  loading, title, category, subtitle, size, data, history, logo, fetchRequest }) => (
  <div>
        {loading && (
                  <Loadingbar />
            )}
        <Gallery title={title} subtitle={subtitle} size={size} loading={loading} data={data} fetchRequest={fetchRequest} category={category} history={history} />


      </div>
)


export default IndexLayout

